// standard sort values used in explore learnings filters
export enum SortValue {
  SameOUFirst = 'same-ou-first',
  MostSkillsCovered = 'most-skills-covered',
  AZ = 'a-z',
  ZA = 'z-a',
}

export interface SortOption {
  key: string
  value: SortValue
}

// full set of options shown in the community filter
export const communitySortOptions: SortOption[] = [
  { key: 'Same OU first', value: SortValue.SameOUFirst },
  { key: 'Most Skills Covered', value: SortValue.MostSkillsCovered },
  { key: 'A-Z', value: SortValue.AZ },
  { key: 'Z-A', value: SortValue.ZA },
]

// reduced alphabetic options used by resources filter
export const alphaSortOptions: SortOption[] = [
  { key: 'A-Z', value: SortValue.AZ },
  { key: 'Z-A', value: SortValue.ZA },
]
